(() => {
  for (const form of document.querySelectorAll('[data-bs-native-sort]')) {
    form.querySelector('select')?.addEventListener('change', () => form.requestSubmit());
  }
  for (const nav of document.querySelectorAll('[data-bs-scroll-nav]')) {
    let startX = 0, startScroll = 0, dragging = false, moved = false;
    nav.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      startX = event.clientX; startScroll = nav.scrollLeft; dragging = true; moved = false;
    });
    nav.addEventListener('pointermove', event => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 6) { moved = true; nav.scrollLeft = startScroll - delta; }
    });
    window.addEventListener('pointerup', () => { dragging = false; });
    nav.addEventListener('pointerleave', () => { dragging = false; });
    nav.addEventListener('click', event => { if (moved) { event.preventDefault(); moved = false; } }, true);
    const active = nav.querySelector('[aria-current="page"]');
    if (active && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = Math.max(0, active.offsetLeft - nav.clientWidth / 2 + active.clientWidth / 2);
  }
})();

(() => {
  const menu = document.querySelector('[data-bs-menu]');
  if (!menu) return;
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    if (menu.open && !menu.contains(event.target)) menu.open = false;
  });
})();


(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event.cartData?.item_count;
    if (!Number.isInteger(count)) return;
    for (const link of document.querySelectorAll('.bs-mobile-cart,.bs-mobile-tabs a')) {
      if (link.getAttribute('href') !== routes.cart_url) continue;
      const className = link.classList.contains('bs-mobile-cart') ? 'bs-mobile-cart__count' : 'bs-mobile-tabs__count';
      let badge = link.querySelector('.' + className);
      if (count === 0) {
        badge?.remove();
      } else {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = className;
          link.append(badge);
        }
        badge.textContent = String(count);
      }
    }
  });
})();

